import { useEffect, useState } from 'react';
import { fetchEMQXMonthlyCostData } from '../services/fetchEMQXMonthlyCostData'; 
import { EMQXMonthlyCostData} from '../constants/types';

export const useEMQXMonthlyCostData = (token: string, year: number) => 
{
  const [initialData, setInitialData] = useState<EMQXMonthlyCostData[]>([]);
  const [graphData, setGraphData] = useState<EMQXMonthlyCostData[]>([]);
  const [hasConfirmed, setHasConfirmed] = useState(false);
  const [error, setError] = useState<string | null>(null);
  
  useEffect(() => {
        const getData = async () => {
            const formattedData = await fetchEMQXMonthlyCostData(token, year);
            if (formattedData) 
            {
                setInitialData(formattedData);
                setHasConfirmed(true);
            } 
            else {
                setInitialData([]);
            }
        };
        getData();
    }, []);

    useEffect(() => {
        const getData = async () => {
            const formattedData = await fetchEMQXMonthlyCostData(token, year);
            if (formattedData) {
            setGraphData(formattedData);
            setHasConfirmed(true);
            } else {
            setGraphData([]);
            }
        };
        getData();
    }, [year]);

    return { initialData, graphData, hasConfirmed, error };
};